import React, { Component } from 'react';
import { Table, Button, Card, Select, Input, Popconfirm, Icon, Row, Col, Typography, Alert, Modal } from 'antd';
import CiclicosConfigRequest from '../../services/CiclicosConfig';
import CatalogoRequest from '../../services/Catalogo';
import { openNotification } from '../../util/notificaciones';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { esBarras, getSegmento } from '../../util/generics';
import { roles } from '../../util/Roles';
import { get_id } from '../../util/IdUser';
import AgregarArticulosModal from './AgregarArticulosModal';

const { Option } = Select;
const { Text } = Typography;

export default class CiclicosConfig extends Component {
    state = {
        isAdmin: true,
        isPdvUser: false,

        selectedPdv: null,
        selectedPdvNombre: null,
        selectedFrecuencia: 1,
        searchQuery: '',

        configuraciones: [],
        totales: {
            diario_base: 0,
            diario_adicional: 0,
            semanal: 0,
            total_diario_pdv: 0
        },
        loadingMain: false,
        selectedRowKeysMain: [],
        pageMain: 1,
        pageSizeMain: 20,
        totalCountMain: 0,

        sitios: [],
        loadingSitios: false,
        sitiosOperador: [],

        modalVisible: false,

        sucursalesModalVisible: false,
        sucursalesModalArticulo: '',
        sucursalesModalArticuloId: null,
        sucursalesModalData: [],
        sucursalesModalLoading: false,
        sucursalesModalPage: 1,
        sucursalesModalPageSize: 10,
        sucursalesModalTotal: 0
    };

    componentDidMount() {
        const segmento = getSegmento()
        if (!segmento || esBarras() || !ShowMenuItem([roles.AdminCatalogos])) {
            this.props.history.push({ pathname: "/" })
            return
        }

        const isAdmin = !!ShowMenuItem([roles.Admin]);
        const isPdvUser = !isAdmin;

        this.setState({
            isAdmin: isAdmin,
            isPdvUser: isPdvUser,
            selectedFrecuencia: isPdvUser ? null : 1
        }, () => {
            if (isPdvUser) {
                this.cargarPdvUsuario();
            } else {
                this.cargarSitios();
                this.cargarConfiguraciones();
            }
        });
    }

    componentWillUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
    }

    cargarPdvUsuario = () => {
        CatalogoRequest.CargarSitiosByUsuario(get_id())
            .then(res => {
                const misSitios = res.data || [];

                if (!misSitios.length) {
                    openNotification('El usuario no tiene asignado un Punto de Venta, favor de contactar al Administrador.', 'Aviso');
                    this.limpiarConfiguraciones();
                    return;
                }

                if (misSitios.length === 1) {
                    this.setState({ sitiosOperador: misSitios, selectedPdv: misSitios[0].id, selectedPdvNombre: misSitios[0].nombre }, () => {
                        this.cargarConfiguraciones();
                    });
                } else {
                    this.setState({ sitiosOperador: misSitios, selectedPdv: null, selectedPdvNombre: null });
                }
            })
            .catch(err => {
                openNotification('Error al obtener el Punto de Venta asignado al usuario.', 'Error');
                this.limpiarConfiguraciones();
            });
    };

    limpiarConfiguraciones = () => {
        this.setState({
            selectedPdv: null,
            selectedPdvNombre: null,
            configuraciones: [],
            totales: {
                diario_base: 0,
                diario_adicional: 0,
                semanal: 0,
                total_diario_pdv: 0
            },
            totalCountMain: 0,
            loadingMain: false,
            selectedRowKeysMain: []
        });
    };

    cargarSitios = () => {
        this.setState({ loadingSitios: true });
        CatalogoRequest.CargarSitiosByUsuario(get_id())
            .then(res => {
                this.setState({
                    sitios: res.data || [],
                    loadingSitios: false
                });
            })
            .catch(err => {
                this.setState({ loadingSitios: false });
                openNotification('Error al cargar la lista de Puntos de Venta.', 'Error');
            });
    };

    requierePdvObligatorio = () => {
        const { selectedFrecuencia, selectedPdv } = this.state;
        return (selectedFrecuencia === 2 || selectedFrecuencia === 3) && !selectedPdv;
    };

    cargarConfiguraciones = () => {
        const { selectedPdv, selectedFrecuencia, searchQuery, pageMain, pageSizeMain } = this.state;

        if (this.requierePdvObligatorio()) {
            this.mainRequestSeq = (this.mainRequestSeq || 0) + 1;
            this.setState({
                configuraciones: [],
                totales: {
                    diario_base: 0,
                    diario_adicional: 0,
                    semanal: 0,
                    total_diario_pdv: 0
                },
                totalCountMain: 0,
                loadingMain: false,
                selectedRowKeysMain: []
            });
            return;
        }

        this.setState({ loadingMain: true });

        const requestId = (this.mainRequestSeq = (this.mainRequestSeq || 0) + 1);

        const params = {
            pdv_id: selectedPdv,
            frecuencia_id: selectedFrecuencia,
            search: searchQuery,
            page: pageMain,
            page_size: pageSizeMain
        };

        CiclicosConfigRequest.ListarConfiguraciones(params)
            .then(res => {
                if (requestId !== this.mainRequestSeq) return;
                const responseData = res.data?.data || {};
                this.setState({
                    configuraciones: responseData.articulos || [],
                    totales: responseData.totales || {
                        diario_base: 0,
                        diario_adicional: 0,
                        semanal: 0,
                        total_diario_pdv: 0
                    },
                    totalCountMain: responseData.count || 0,
                    loadingMain: false,
                    selectedRowKeysMain: []
                });
            })
            .catch(err => {
                if (requestId !== this.mainRequestSeq) return;
                this.setState({ loadingMain: false });
                const msg = err?.response?.data?.message || 'Error al cargar las configuraciones de artículos cíclicos.';
                openNotification(msg, 'Error');
            });
    };

    handlePdvChange = (value) => {
        const pdvVal = (value !== undefined && value !== null) ? Number.parseInt(value, 10) : null;
        const { isPdvUser, sitiosOperador } = this.state;
        const nuevoState = { selectedPdv: pdvVal, pageMain: 1 };

        if (isPdvUser) {
            const sitio = sitiosOperador.find(s => Number.parseInt(s.id, 10) === pdvVal);
            nuevoState.selectedPdvNombre = sitio ? sitio.nombre : null;
        }

        this.setState(nuevoState, () => {
            this.cargarConfiguraciones();
        });
    };

    handleFrecuenciaChange = (value) => {
        const frecuenciaVal = (value !== undefined && value !== null) ? Number.parseInt(value, 10) : null;
        this.setState({ selectedFrecuencia: frecuenciaVal, pageMain: 1 }, () => {
            this.cargarConfiguraciones();
        });
    };

    handleSearchMainChange = (e) => {
        const value = e.target ? e.target.value : (e || '');
        this.setState({ searchQuery: value });

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            this.setState({ pageMain: 1 }, () => {
                this.cargarConfiguraciones();
            });
        }, 400);
    };

    handleDeleteSingle = (record) => {
        this.setState({ loadingMain: true });
        const requestPromise = (record && record.id > 0)
            ? CiclicosConfigRequest.EliminarConfiguracionesLote([record.id])
            : CiclicosConfigRequest.EliminarArticulosMasivoLote([record.idArticuloInventario]);

        requestPromise
            .then(res => {
                const msg = res?.data?.message || 'El artículo fue eliminado de todas sus configuraciones cíclicas.';
                openNotification(msg, 'Éxito');
                this.cargarConfiguraciones();
            })
            .catch(err => {
                this.setState({ loadingMain: false });
                const msg = err?.response?.data?.message || 'Error al eliminar la configuración.';
                openNotification(msg, 'Error');
            });
    };

    getRowKeyMain = (record) => `${record.id}-${record.idArticuloInventario}-${record.pdv_id ?? 'n'}-${record.frecuencia_id ?? 'n'}`;

    handleDeleteBulk = () => {
        const { isAdmin, selectedRowKeysMain, configuraciones } = this.state;
        if (selectedRowKeysMain.length === 0) return;

        const selectedItems = configuraciones.filter(c => selectedRowKeysMain.includes(this.getRowKeyMain(c)));

        let deleteRequest;

        if (isAdmin) {
            const artIds = Array.from(new Set(selectedItems.map(c => c.idArticuloInventario)));
            deleteRequest = CiclicosConfigRequest.EliminarArticulosMasivoLote(artIds);
        } else {
            const itemsEliminables = selectedItems.filter(c => c.frecuencia_id !== 1 && c.id > 0);
            if (itemsEliminables.length === 0) {
                openNotification('No hay artículos seleccionados que puedas eliminar.', 'Aviso');
                return;
            }
            const ids = itemsEliminables.map(c => c.id);
            deleteRequest = CiclicosConfigRequest.EliminarConfiguracionesLote(ids);
        }

        this.setState({ loadingMain: true });

        deleteRequest
            .then(res => {
                const msg = res?.data?.message || 'Se eliminaron los artículos seleccionados.';
                openNotification(msg, 'Éxito');
                this.cargarConfiguraciones();
            })
            .catch(err => {
                this.setState({ loadingMain: false });
                const msg = err?.response?.data?.message || 'Error al eliminar los artículos seleccionados.';
                openNotification(msg, 'Error');
            });
    };

    handleOpenModal = () => {
        this.setState({ modalVisible: true });
    };

    handleCloseModal = () => {
        this.setState({ modalVisible: false });
    };

    handleVerSucursales = (record) => {
        this.setState({
            sucursalesModalVisible: true,
            sucursalesModalArticulo: record.nombre,
            sucursalesModalArticuloId: record.idArticuloInventario,
            sucursalesModalData: [],
            sucursalesModalPage: 1,
            sucursalesModalTotal: 0
        }, () => {
            this.cargarSucursalesModal();
        });
    };

    cargarSucursalesModal = () => {
        const { selectedFrecuencia, sucursalesModalArticuloId, sucursalesModalPage, sucursalesModalPageSize } = this.state;
        if (!sucursalesModalArticuloId) return;

        this.setState({ sucursalesModalLoading: true });

        CiclicosConfigRequest.ListarSucursalesArticulo(sucursalesModalArticuloId, {
            frecuencia_id: selectedFrecuencia,
            page: sucursalesModalPage,
            page_size: sucursalesModalPageSize
        })
            .then(res => {
                const responseData = res.data?.data || {};
                this.setState({
                    sucursalesModalData: responseData.sucursales || [],
                    sucursalesModalTotal: responseData.count || 0,
                    sucursalesModalLoading: false
                });
            })
            .catch(err => {
                this.setState({ sucursalesModalLoading: false });
                const msg = err?.response?.data?.message || 'Error al cargar los Puntos de Venta del artículo.';
                openNotification(msg, 'Error');
            });
    };

    handleCerrarSucursalesModal = () => {
        this.setState({
            sucursalesModalVisible: false,
            sucursalesModalArticulo: '',
            sucursalesModalArticuloId: null,
            sucursalesModalData: [],
            sucursalesModalPage: 1,
            sucursalesModalTotal: 0
        });
    };

    render() {
        const {
            isAdmin,
            isPdvUser,
            selectedPdv,
            selectedPdvNombre,
            selectedFrecuencia,
            searchQuery,
            configuraciones,
            totales,
            loadingMain,
            selectedRowKeysMain,
            pageMain,
            pageSizeMain,
            totalCountMain,
            sitios,
            loadingSitios,
            sitiosOperador,
            modalVisible,
            sucursalesModalVisible,
            sucursalesModalArticulo,
            sucursalesModalData,
            sucursalesModalLoading,
            sucursalesModalPage,
            sucursalesModalPageSize,
            sucursalesModalTotal
        } = this.state;

        const rowSelectionMain = {
            selectedRowKeys: selectedRowKeysMain,
            onChange: (selectedRowKeys) => {
                this.setState({ selectedRowKeysMain: selectedRowKeys });
            },
            getCheckboxProps: (record) => ({
                disabled: !isAdmin && (record.frecuencia_id === 1 || record.id <= 0)
            })
        };

        const requierePdv = this.requierePdvObligatorio();
        const soloDiarioBase = isAdmin && !selectedPdv;

        const columnsMain = [
            {
                title: 'Código',
                dataIndex: 'codigo',
                key: 'codigo',
                width: 120
            },
            {
                title: 'Nombre',
                dataIndex: 'nombre',
                key: 'nombre'
            },
            {
                title: 'UDMA',
                dataIndex: 'udma',
                key: 'udma',
                width: 120,
                align: 'center'
            },
            {
                title: 'UDMV',
                dataIndex: 'udmv',
                key: 'udmv',
                width: 120,
                align: 'center'
            },
            {
                title: 'Frecuencia',
                dataIndex: 'frecuencia',
                key: 'frecuencia',
                width: 160,
                align: 'center',
                render: (value, record) => (
                    record.tiene_sucursales ? (
                        <Button type="link" onClick={() => this.handleVerSucursales(record)} style={{ padding: 0, height: 'auto' }}>
                            {value}
                        </Button>
                    ) : (
                        <span>{value}</span>
                    )
                )
            },
            {
                title: 'Acciones',
                key: 'acciones',
                width: 100,
                align: 'center',
                render: (text, record) => {
                    if (isAdmin || (!isAdmin && record.frecuencia_id != 1)) {
                        return (
                            <Popconfirm
                                title="¿Está seguro de eliminar este artículo del conteo cíclico?"
                                onConfirm={() => this.handleDeleteSingle(record)}
                                okText="Sí, eliminar"
                                cancelText="Cancelar"
                                okType="danger"
                            >

                                <Button
                                    type="danger"
                                    icon="delete"
                                    size="small"
                                />
                            </Popconfirm>
                        );
                    }

                }
            }
        ];

        return (
            <div>
                <Card id="ParentSize"
                    title="Artículos cíclicos"
                    extra={
                        <span>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 12 }}
                                    disabled={!isAdmin && !selectedPdv}
                                    onClick={this.handleOpenModal}
                                >
                                    Agregar artículos
                                </Button>
                            <Button
                                disabled={selectedRowKeysMain.length === 0}
                                onClick={this.handleDeleteBulk}
                            >
                                Eliminar artículos
                            </Button>
                        </span>
                    }
                >
                    <Row gutter={24} style={{ marginBottom: 24 }}>
                        <Col span={12}>
                            <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>
                                Punto de Venta{requierePdv && <span style={{ color: '#f5222d' }}> *</span>}
                            </div>
                            <Select
                                showSearch
                                allowClear={isAdmin}
                                disabled={isPdvUser && sitiosOperador.length <= 1}
                                placeholder="Seleccionar..."
                                style={{ width: '100%' }}
                                value={selectedPdv !== null && selectedPdv !== undefined ? Number.parseInt(selectedPdv, 10) : undefined}
                                onChange={this.handlePdvChange}
                                loading={loadingSitios}
                                optionFilterProp="children"
                                filterOption={(input, option) => {
                                    const text = typeof option.props.children === 'string' ? option.props.children : '';
                                    return text.toLowerCase().includes(input.toLowerCase());
                                }}
                            >
                                {isPdvUser ? sitiosOperador.map(s => {
                                    const sId = Number.parseInt(s.id, 10);
                                    return (
                                        <Option key={sId} value={sId}>
                                            {s.nombre || `PDV ${sId}`}
                                        </Option>
                                    );
                                }) : sitios.map(s => {
                                    const sId = Number.parseInt(s.id, 10);
                                    return (
                                        <Option key={sId} value={sId}>
                                            {s.nombre || s.cr || `PDV ${sId}`}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Col>

                        <Col span={12}>
                            <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Frecuencia:</div>
                            <Select
                                allowClear
                                placeholder="Seleccionar..."
                                style={{ width: '100%' }}
                                value={selectedFrecuencia !== null && selectedFrecuencia !== undefined ? selectedFrecuencia : undefined}
                                onChange={this.handleFrecuenciaChange}
                            >
                                <Option value={1}>Diario Base</Option>
                                <Option value={2}>Diario Adicional</Option>
                                <Option value={3}>Semanal</Option>
                            </Select>

                        </Col>
                    </Row>

                    <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col span={8}>
                            <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Búsqueda:</div>
                            <Input
                                placeholder="Buscar por Código / Nombre"
                                prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={searchQuery}
                                onChange={this.handleSearchMainChange}
                                allowClear
                            />
                        </Col>
                        <Col span={12} style={{ textAlign: 'right' }}>
                            {soloDiarioBase ? (
                                <span style={{ fontSize: 18, fontWeight: 600 }}>
                                    Diario Base: <Text style={{ fontSize: 18, fontWeight: 700 }}>{totales.diario_base}</Text>
                                </span>
                            ) : (
                                <>
                                    <span style={{ fontSize: 18, fontWeight: 600, marginRight: 32 }}>
                                        Diarios: <Text style={{ fontSize: 18, fontWeight: 700 }}>{totales.total_diario_pdv}</Text>
                                    </span>
                                    <span style={{ fontSize: 18, fontWeight: 600 }}>
                                        Semanales: <Text style={{ fontSize: 18, fontWeight: 700 }}>{totales.semanal}</Text>
                                    </span>
                                </>
                            )}
                        </Col>
                    </Row>

                    {requierePdv && (
                        <Alert
                            type="warning"
                            showIcon
                            message="Seleccione un Punto de Venta para visualizar los artículos configurados con frecuencia Diario Adicional o Semanal."
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    <Table
                        rowSelection={rowSelectionMain}
                        columns={columnsMain}
                        dataSource={configuraciones}
                        rowKey={this.getRowKeyMain}
                        loading={loadingMain}
                        scroll={{ y: 600 }}
                        pagination={{
                            current: pageMain,
                            pageSize: pageSizeMain,
                            total: totalCountMain,
                            onChange: (page, pageSize) => {
                                this.setState({ pageMain: page, pageSizeMain: pageSize }, () => {
                                    this.cargarConfiguraciones();
                                });
                            },
                            onShowSizeChange: (page, pageSize) => {
                                this.setState({ pageMain: 1, pageSizeMain: pageSize }, () => {
                                    this.cargarConfiguraciones();
                                });
                            },
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100']
                        }}
                        locale={{ emptyText: requierePdv ? 'Seleccione un Punto de Venta para continuar.' : 'No hay artículos cíclicos configurados.' }}
                    />
                </Card>

                <AgregarArticulosModal
                    visible={modalVisible}
                    isAdmin={isAdmin}
                    selectedPdv={selectedPdv}
                    selectedPdvNombre={selectedPdvNombre}
                    onClose={this.handleCloseModal}
                    onSaved={this.cargarConfiguraciones}
                />

                <Modal
                    title={`Puntos de venta - ${sucursalesModalArticulo}`}
                    visible={sucursalesModalVisible}
                    onCancel={this.handleCerrarSucursalesModal}
                    footer={null}
                    width={800}
                    destroyOnClose
                >
                    <Table
                        columns={[
                            { title: 'Punto de Venta', dataIndex: 'pdv_nombre', key: 'pdv_nombre' },
                            { title: 'Frecuencia', dataIndex: 'frecuencia', key: 'frecuencia', width: 180, align: 'center' }
                        ]}
                        dataSource={sucursalesModalData}
                        rowKey="id"
                        size="small"
                        loading={sucursalesModalLoading}
                        pagination={{
                            current: sucursalesModalPage,
                            pageSize: sucursalesModalPageSize,
                            total: sucursalesModalTotal,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50'],
                            onChange: (page, pageSize) => {
                                this.setState({ sucursalesModalPage: page, sucursalesModalPageSize: pageSize }, () => {
                                    this.cargarSucursalesModal();
                                });
                            },
                            onShowSizeChange: (page, pageSize) => {
                                this.setState({ sucursalesModalPage: 1, sucursalesModalPageSize: pageSize }, () => {
                                    this.cargarSucursalesModal();
                                });
                            }
                        }}
                    />
                </Modal>
            </div>
        );
    }
}
